export default __webpack_public_path__ + "static/media/47fc9598358ad5c46f340386383ccb6d.png";